import { render, staticRenderFns } from "./TableCellText.vue?vue&type=template&id=1705a668&"
import script from "./TableCellText.vue?vue&type=script&lang=ts&"
export * from "./TableCellText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports